<template>
  <v-sheet
    rounded="xl"
    class="text-start px-6 py-8"
    maxWidth="786px"
    :width="$vuetify.breakpoint.smAndUp && $vuetify.breakpoint.mdAndDown ? '586px' : ''"
  >
    <stepper :completeStep="2" :currentStep="2" />
    <v-row class="px-3">
      <v-col cols="12 text-medium pb-0"> Confirm </v-col>
      <v-col cols="12">
        <table width="100%">
          <tbody>
            <tr>
              <td>
                <div class="text-h5 font-weight-medium">
                  {{ bnbInfo.balance | formatNumber(8) }} {{ bnbInfo.symbol }}
                </div>
                <div class="grey--text text--body-1">Your {{ bnbInfo.symbol }} balance</div>
              </td>
              <td :class="isError ? ' line-error' : ''">
                <div class="text-h5 font-weight-medium">
                  {{ selectedToken.balance | formatNumber(10) }} {{ selectedToken.symbol }}
                </div>
                <div class="text--body-1" :class="isError ? ' line-error' : 'grey--text'">
                  Your {{ selectedToken.symbol }} balance
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="text-h5 font-weight-medium">
                  {{ bulkSendInfo.totalTokens | formatNumber(8) }} {{ selectedToken.symbol }}
                </div>
                <div class="grey--text text--body-1">Total number of token to be sent</div>
              </td>
              <td>
                <div class="text-h5 font-weight-medium">{{ editorData.length }}</div>
                <div class="grey--text text--body-1">Total number of address</div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="text-h5 font-weight-medium">{{ bulkSendInfo.transNumber }}</div>
                <div class="grey--text text--body-1">Total number of transaction needed</div>
              </td>
              <td>
                <div
                  class="text-h5 font-weight-medium"
                  :class="isError || !isApproved ? 'line-error' : ''"
                  v-if="!estimateGasLoading"
                >
                  <span v-if="!isError && isApproved">
                    {{ estimateGas | formatNumber(8) }}
                  </span>
                  {{ isError ? 'Insufficient balance' : isApproved ? `BNB` : 'Waiting for approval' }}
                </div>
                <div v-else>
                  <v-progress-circular
                    indeterminate
                    color="primary"
                    :size="20"
                    class="ml-10 d-flex align-center"
                  ></v-progress-circular>
                </div>
                <div class="grey--text text--body-1">Estimated Gas</div>
              </td>
            </tr>
          </tbody>
        </table>
      </v-col>
      <v-col cols="12" v-if="isError">
        <v-sheet rounded="xl" class="secondary lighten-3 pa-6 frame-error">
          <div class="line-error text-body-1">Insufficient token balance</div>
        </v-sheet>
      </v-col>
      <v-col cols="12" class="d-flex justify-space-between pb-0">
        <v-btn rounded class="primary" min-width="120px" @click="$router.go(-1)">Back</v-btn>
        <v-btn
          rounded
          class="primary"
          min-width="120px"
          v-if="isApproved"
          :loading="fetching"
          @click="$router.push('sending')"
          :disabled="isError"
          >Send</v-btn
        >
        <v-btn rounded class="primary" min-width="120px" v-else @click="onApprove()" :loading="approving || fetching"
          >Approve</v-btn
        >
      </v-col>
    </v-row>
  </v-sheet>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import fixedNumberHelper from '@/helpers/fixedNumberHelper.js'
import Stepper from '@/components/base/Stepper.vue'
export default {
  components: {
    Stepper,
  },
  data() {
    return {
      estimateGasLoading: false,
    }
  },
  computed: {
    ...mapState('bulkSendPrepare', ['selectedToken', 'bulkSendInfo', 'estimateGas', 'editorData', 'isSendSameValue']),
    ...mapState('bulkSendConfirm', ['approving', 'isApproved', 'fetching']),
    ...mapState('auth', ['bnbInfo', 'multiSendHandler', 'account']),
    isError: function () {
      return fixedNumberHelper.gt(this.bulkSendInfo.totalTokens, this.selectedToken.balance)
    },
  },
  methods: {
    ...mapActions('bulkSendConfirm', ['onApproveContract', 'fetchData']),
    ...mapActions('bulkSendPrepare', ['handleEstimateGas']),
    async onApprove() {
      this.estimateGasLoading = true
      await this.onApproveContract([this.multiSendHandler, this.selectedToken])
      if (this.isApproved) {
        const estimateGas = await this.handleEstimateGas([this.bulkSendInfo.maxAccountPerTrans, this.isSendSameValue])
        this.$store.commit('bulkSendPrepare/changeState', { estimateGas })
      }
      this.estimateGasLoading = false
    },
  },
  async created() {
    await this.fetchData([this.multiSendHandler, this.selectedToken])
  },
}
</script>
<style scoped>
td {
  padding-top: 18px;
  padding-left: 18px;
  padding-bottom: 18px;
}
table,
th,
td {
  border: 1px solid gray;
  border-collapse: collapse;
}
.line-error {
  color: var(--v-error-lighten1) !important;
}
</style>
